import { Alert, Row } from "antd";
import { ReactNode, useCallback, useEffect, useMemo } from "react";
import { useScrollToDiv } from "../../../../../../../../../lib/hooks/useScrollToDiv";

type ErrorContainerProps = {
  error: any;
};

export const ErrorContainer = ({ error }: ErrorContainerProps) => {
  const { ref, scrollToDiv } = useScrollToDiv();

  const getRegularError = useCallback((): string => {
    const data = error.response.data;

    if (data.errors) {
      const title: string = Object.keys(data.errors)[0];

      return data.errors[title][0];
    } else {
      return data.title;
    }
  }, [error]);

  const message: ReactNode = useMemo(() => {
    const { additionalData } = error;

    if (additionalData) {
      const err = Object.keys(error.failedItems);

      const { succesfullySentTo } = additionalData;

      const succeded = succesfullySentTo ? succesfullySentTo.split(",") : [];

      return (
        <Row className="d-block">
          <Row className="d-block mb-2">Emails for some recievers were not delivered:</Row>
          <ul className="my-0">
            {err.map((item: string, i: number) => (
              <li key={i}>{item === "generalErrorMessage" ? error.failedItems[item] : item}</li>
            ))}
          </ul>
          {succeded.length > 0 && (
            <>
              <Row className="d-block my-2">Delivered emails:</Row>
              <ul className="my-0">
                {succeded.map((item: string, i: number) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </>
          )}
        </Row>
      );
    } else {
      return <Row className="d-block">{getRegularError()}</Row>;
    }
  }, [error, getRegularError]);

  useEffect(() => scrollToDiv(), [message, ref, scrollToDiv]);

  return (
    <Row ref={ref} className="d-block">
      <Alert message={message} showIcon type="error" className="mb-4" />
    </Row>
  );
};
